<!-- eslint-disable vuejs-accessibility/heading-has-content -->
<!-- eslint-disable vuejs-accessibility/form-control-has-label -->
<template>
     <div class="footer">
      <div class="footer__logo">
        <img src="https://anytour.onrender.com/img/logo-white.png" alt="Natours logo" />
      </div>
      <ul class="footer__nav">
        <li><a href="#">About us</a></li>
        <li><a href="#">Download apps</a></li>
        <li><a href="#">Become a guide</a></li>
        <li><a href="#">Careers</a></li>
        <li><a href="#">Contact</a></li>
      </ul>
      <p class="footer__copyright">
        &copy; by Jonas Schmedtmann. All rights reserved.
      </p>
    </div>
</template>

<script>

export default {
  name: 'FooterView',
  data() {
    return {
    };
  },

};
</script>

<style>

</style>
